import { render, staticRenderFns } from "./commissionDetail.vue?vue&type=template&id=6526fce8&scoped=true"
import script from "./commissionDetail.vue?vue&type=script&lang=js"
export * from "./commissionDetail.vue?vue&type=script&lang=js"
import style0 from "./commissionDetail.vue?vue&type=style&index=0&id=6526fce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526fce8",
  null
  
)

export default component.exports